import {
  DocumentTextIcon,
  PhoneIncomingIcon,
  ShieldExclamationIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";

export const resourcesLinks = [
  {
    name: "Documentation",
    href: "documentation",
    icon: DocumentTextIcon,
  },
  {
    name: "FAQ",
    href: "faq",
    icon: ShieldExclamationIcon,
  },
  {
    name: "About Us",
    href: "about-us",
    icon: UserGroupIcon,
  },
  {
    name: "Contact Us",
    href: "contact-us",
    icon: PhoneIncomingIcon,
  },
];
